import { AdjustmentBounds } from "../../../general";
import { Bounds } from "../../../utilities/BoundsObserver/Bounds";

/**
 * Gets the vertical adjustment for a dropdown menu so it stays inside every bounding region it must respect.
 * The menu opens below the control by default and flips above it only when it does not fit below. If it fits
 * in neither direction, the side with the most room wins.
 * @param menuBounds The bounds of the menu when placed below the control.
 * @param controlHeight The distance from the top of the menu to the top of the control, used to place the menu above it.
 * @param regions The bounding regions the menu should stay within, such as the overlay container and the surrounding modal.
 * @returns The adjusted bounds to apply to the menu.
 */
export function getMenuAdjustment(menuBounds: Bounds, controlHeight: number, regions: ReadonlyArray<Bounds>): AdjustmentBounds {
  const { top, left, height } = menuBounds;

  const regionTop = Math.max(...regions.map((region) => region.top));
  const regionBottom = Math.min(...regions.map((region) => region.top + region.height));

  const spaceBelow = regionBottom - top;
  const spaceAbove = top - controlHeight - regionTop;

  const fitsBelow = height <= spaceBelow;
  const fitsAbove = height <= spaceAbove;

  if (fitsBelow || (!fitsAbove && spaceBelow >= spaceAbove)) return { top, left };

  return {
    top: top - height - controlHeight,
    left: "auto",
  };
}
